import { render, staticRenderFns } from "./RegisterByEmail.vue?vue&type=template&id=12671e72&scoped=true&"
import script from "./RegisterByEmail.vue?vue&type=script&lang=js&"
export * from "./RegisterByEmail.vue?vue&type=script&lang=js&"
import style0 from "./RegisterByEmail.vue?vue&type=style&index=0&id=12671e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12671e72",
  null
  
)

export default component.exports